import React, { useContext } from 'react';
import { Container, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link } from 'react-scroll';
import pdf from '../../images/Kevin-Resume.pdf'
import PortfolioContext from '../../context/context';

const Footer = () => {
  const { footer } = useContext(PortfolioContext);
  const { networks } = footer;

  const capitalize = (name)=>{
    return name.charAt(0).toUpperCase() + name.substring(1)
  }
  return (
    <footer className="footer navbar-static-bottom">
      <Container>
        <span className="back-to-top">
          <Link to="hero" smooth duration={100}>
            <i className="fa fa-angle-up fa-2x" aria-hidden="true" />
          </Link>
        </span>
        <div className="social-links">
          {networks &&
            networks.map((network) => {
              const { id, name, url } = network;
              let faName = name
              let hrefURL=url
              if(name==='resume'){
                faName='file'
                hrefURL=pdf
              }
              return (
                <OverlayTrigger
                  key={id}
                  placement={'top'}
                  overlay={<Tooltip id={`tooltip-${name}`}><h3>{capitalize(name)}</h3></Tooltip>}
                >
                  <a
                    key={id}
                    href={hrefURL || 'https://github.com/cobidev/gatsby-simplefolio'}
                    rel="noopener noreferrer"
                    target="_blank"
                    aria-label={name}
                    >
                    <i className={`fa fa-${faName || 'refresh'} fa-inverse`} />
                  </a>
                </OverlayTrigger>
              );
            })}
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
